function nonNull<T>(value: T | typeof undefined | null): T {
  if (value == null) {
    throw new Error('unexpected null');
  }

  return value as T;
}

export { nonNull };
